import { render, staticRenderFns } from "./termsModal.vue?vue&type=template&id=652c12c0&scoped=true&"
import script from "./termsModal.vue?vue&type=script&lang=js&"
export * from "./termsModal.vue?vue&type=script&lang=js&"
import style0 from "./termsModal.vue?vue&type=style&index=0&id=652c12c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652c12c0",
  null
  
)

export default component.exports